import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { VOUCHERS_ADD } from '../../constants/routes';
import { ROLE_USER } from '../../constants/roles';
import { getVouchers } from '../../store/vouchers/actions';
import VoucherTable from '../../components/Voucher/VoucherTable';
import { getRenters } from '../../store/renters/actions';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => (
  {
    addButton: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      bottom: '3vh',
      right: '3vh',
    },
  }
));

export const VouchersPage = () => {

  const classes = useStyles();
  const { authUser } = useSelector(state => state.users);
  const dispatch = useDispatch();
  const [displayedVouchers, setDisplayedVouchers] = useState(null);
  const roles = useSelector(state => state.roles.content);
  const vouchers = useSelector(state => state.vouchers);
  const renters = useSelector(state => state.renters);

  const pending = renters.pending || vouchers.pending;
  const role = roles[authUser.uid] !== undefined ? roles[authUser.uid] : ROLE_USER;

  if (authUser && roles) {
    if (!vouchers.content && !vouchers.pending && vouchers.error === null) {
      dispatch(getVouchers(authUser.ma, role));
    }
    if (!renters.content && !renters.pending && renters.error === null) {
      dispatch(getRenters(authUser.ma, role));
    }

    if (
      vouchers.content
      && !vouchers.pending
      && vouchers.error === null
      && renters.content
      && !renters.pending
      && renters.error === null
      && displayedVouchers === null
      ) {
      let newVouchers = vouchers.content.map((voucher) => {
        let v = {...voucher};
        v.siteName = '';
        v.sites.forEach((site) => {
          v.siteName += site.name + ' ';
          v.renterName = renters.content.find(
            renter => renter.id === v.sites[0].renter_info_id,
          ).name;
        });
        return v;
      });
      setDisplayedVouchers(newVouchers);
    }
  }

  return (
    <LargePaper>
      <h1 style={stylesDefault.title}>Coupons</h1>
      <Fab
        className={classes.addButton}
        color="primary"
        component={Link}
        aria-label="add"
        to={VOUCHERS_ADD}
      >
        <AddIcon />
      </Fab>
      <VoucherTable
        vouchers={displayedVouchers}
        pending={pending}
      />
    </LargePaper>
  );
};

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(VouchersPage);



// WEBPACK FOOTER //
// ./src/containers/VouchersPage/VouchersPage.jsx